import React, { useEffect } from "react";
import { Tabs, TabPane } from "@douyinfe/semi-ui";
import { IconStackBarChartStroked, IconPieChartStroked, } from "@douyinfe/semi-icons";
import TrendDashboard from "./trendDashboard";
import OverallDashboard from "./overallDashboard";

export default function DataVisual() {

  useEffect(() => {

  }, []);



  return (
    <Tabs type="line" style={{ margin: 10 }}>
      <TabPane
        tab={
          <span>
            <IconStackBarChartStroked />
            趋势
          </span>
        }
        itemKey="1"
      >
        <TrendDashboard />
      </TabPane>
      <TabPane
        tab={
          <span>
            <IconPieChartStroked />
            总览
          </span>
        }
        itemKey="2"
      >
        <OverallDashboard />
      </TabPane>
    </Tabs>
  );
}
